import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import NavBar from './components/NavBar';
import MagazineDetail from './pages/MagazineDetail';
import PublicationDetail from './pages/PublicationDetail';


function App() {
  return (
    // use bootstrap navbar for react
    <>
      <BrowserRouter> 
        <NavBar></NavBar>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/magazine/:magazineId" element={<MagazineDetail />} />
          <Route path="/magazine/:magazineId/publication/:publicationId" element={<PublicationDetail />} />
          <Route path="/magazine/:magazineId/publication/:publicationId/fullscreen" element={<PublicationDetail />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
